
import { onMounted, ref, reactive, computed, inject } from 'vue'
import NewActionBar from '@/components/NewActionBar.vue'
import { nativeGoBack, nativeToast, doJump } from '@/utils/nativeFn'
import store from '@/store/index'
import QuestionAnalysis from './QuestionAnalysis.vue'
import { addWrongQuestionBatch, cancelWrongQuestionBatch } from '@/api'
import { useRoute } from 'vue-router'
export default {
  name: 'CardDetail',
  components: {
    NewActionBar,
    QuestionAnalysis
  },
  props: {
    paperId: {
      type: String,
      default: 'de776b17b3674a0d9ee5ea009d174971'
    },
    sourceLocation: {
      type: String,
      default: 'null_source'
    }
  },
  emits: ['doRetry'],
  setup(props, { emit }) {
    const $xesLog = inject('$xesLog') as any // 埋点
    const { sourceLocation: source_location } = props

    const { source_location: source } = useRoute().query
    const isWeekStudy = computed(() => source === 'itembank') // 周周练添加

    const showAnswerAnalysis = ref(false)
    const currentIndex = ref(0)
    const actionBarInfo = reactive({}) // actionBar需要的参数
    const testLevelInfoList = [
      {},
      {
        inspireText: '需要比现在更努力一些些哟！',
        bgKey: 'notyet'
      },
      {
        inspireText: '还不错，但要继续加油哦！',
        bgKey: 'pass'
      },
      {
        inspireText: '继续努力冲刺更高分吧！',
        bgKey: 'good'
      },
      {
        inspireText: '太厉害了，一定要继续保持哦！',
        bgKey: 'perfect'
      }
    ]
    const testLevel = ref(0)
    const isAllDecidable = computed(() => store.getters['taskPaper/isAllDecidable'])
    const score = computed(() => store.getters['taskPaper/correctPercent'])
    const questionList = computed(() => {
      return store.getters['taskPaper/queResList']
    })
    const wrongNum = ref(0)
    const handleWrongList = () => {
      const wrongIds = []
      const rightIds = []
      questionList.value.forEach((item) => {
        if (item.ansResStatus === 1) {
          item.queId && rightIds.push(item.queId)
        } else {
          item.queId && wrongIds.push(item.queId)
        }
      })
      if (wrongIds.length) {
        addWrongQuestionBatch({ nry_question_ids: wrongIds.join(',') })
          .then((res) => {
            wrongNum.value = wrongIds.length
            nativeToast('错题已自动加入错题本')
          })
          .catch((err) => {})
      }
      if (rightIds.length) {
        cancelWrongQuestionBatch({ nry_question_ids: rightIds.join(',') })
      }
    }
    // 初始化弹窗
    const initActionBar = () => {
      Object.assign(actionBarInfo, {
        actionBarTitle: '练习报告',
        actionBarBg: 'transparent'
      })
    }
    const preventDefaultEvent = () => {
      return false
    }
    const reTry = () => {
      $xesLog.track('test_report_click', {
        source_location: isWeekStudy ? 'itembank' : source_location,
        page_name: isWeekStudy ? 'itembank' : 'test_report',
        biz_name: 'int_lear',
        event_type: 'click',
        one_more: 'one_more'
      })
      emit('doRetry')
    }
    const finish = () => {
      $xesLog.track('test_report_click', {
        source_location: isWeekStudy ? 'itembank' : source_location,
        page_name: isWeekStudy ? 'itembank' : 'test_report',
        biz_name: 'int_lear',
        event_type: 'click',
        back: 'back'
      })
      nativeGoBack({}, (res) => {
        console.log('h5调用端上nativeGoBack', res) // app返回给前端的值
      })
    }
    const gotoWrongList = () => {
      wrongNum.value = 0
      const mainPath = window.location.href.split('#')[0]
      const path = `10001?parameters=${encodeURIComponent(
        JSON.stringify({
          url: `${mainPath}#/wrong-question-list?source_location=${
            isWeekStudy ? 'itembank' : 'test_report'
          }`
        })
      )}`

      // actionbar 错题本点击事件
      $xesLog.track('false_notebook_click', {
        page_name: isWeekStudy ? 'itembank_test_report' : 'test_report',
        event_type: 'click'
      })
      doJump(path, () => {
        console.log('跳转成功')
      })
    }
    const goResolution = (item, index) => {
      $xesLog.track('test_report_click', {
        source_location: isWeekStudy ? 'itembank' : source_location,
        page_name: isWeekStudy ? 'itembank' : 'test_report',
        biz_name: 'int_lear',
        event_type: 'click',
        exercise_click: 'exercise_click'
      })
      currentIndex.value = index
      showAnswerAnalysis.value = true
      wrongNum.value = 0
      document.title = '答题解析'
    }
    const closeAnalysis = () => {
      showAnswerAnalysis.value = false
    }
    const initDescInfoByScore = () => {
      if (+score.value < 60) {
        testLevel.value = 1
      } else if (+score.value >= 60 && +score.value < 80) {
        testLevel.value = 2
      } else if (+score.value >= 80 && +score.value < 100) {
        testLevel.value = 3
      } else if (+score.value === 100) {
        testLevel.value = 4
      }
    }
    onMounted(() => {
      // 初始化actionbar的标题信息
      initActionBar()
      // 根据分数生成成绩描述
      initDescInfoByScore()
      // 操作加入、移除错题本
      handleWrongList()
      document.title = '练习报告'
      $xesLog.view(
        'test_report_pv',
        {
          source_location: isWeekStudy ? 'itembank' : source_location,
          page_name: isWeekStudy ? 'itembank' : 'test_report',
          biz_name: 'int_lear',
          event_type: 'pv'
        },
        () => {
          console.log('埋点成功')
        }
      )
    })
    return {
      actionBarInfo,
      showAnswerAnalysis,
      store,
      reTry,
      finish,
      goResolution,
      isWeekStudy,
      score,
      questionList,
      isAllDecidable,
      closeAnalysis,
      preventDefaultEvent,
      currentIndex,
      testLevelInfoList,
      testLevel,
      wrongNum,
      gotoWrongList,
      source
    }
  }
}
